import { Tabs } from 'antd';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { useSelector } from '@redux';
import { DynamicObjectType } from 'types/commons';
import OrdersList from '../List/BatchList/OrdersList';
import ItemsList from '../List/BatchList/ItemsList';
import ConfirmReceivedButton from '../components/ConfirmReceivedButton';
import BatchBreadCrumb from '../components/BatchBreadCrumb';
import { useGetFilter } from 'hooks/useSearchParamsObj';

const BatchDetail = () => {
  const { t } = useTranslation();

  const [tabList, setTabList] = useState('orders');

  const { searchParams, setSearchParams } = useGetFilter();

  const currentBatch = useSelector<DynamicObjectType>(
    (state) => state.transferOrdersBatch.currentData,
  );

  const DETAIL_TABS = useMemo(() => {
    return [
      {
        text: 'Order List',
        value: 'orders',
        components: currentBatch && (
          <OrdersList
            selectedData={currentBatch?.transferOrders?.map((item) => item?.id)}
            isDetail
          />
        ),
      },
      {
        text: 'Item List',
        value: 'items',
        components: currentBatch && (
          <ItemsList
            selectedData={currentBatch?.transferOrders?.map((item) => item?.id)}
            isDetail
          />
        ),
      },
    ];
  }, [currentBatch]);

  const handleChangeTab = (key) => {
    searchParams.delete('q');
    searchParams.delete('fieldSearch');
    setSearchParams(searchParams);
    setTabList(key);
  };

  return (
    <>
      <div className="flex justify-between items-center">
        <BatchBreadCrumb />
        <ConfirmReceivedButton data={currentBatch} />
      </div>

      <Tabs activeKey={tabList} onChange={(e) => handleChangeTab(e)}>
        {DETAIL_TABS.map((e) => (
          <Tabs.TabPane
            tab={t(e.text)}
            key={e.value}
            tabKey={e.value}
            children={e?.components}
          />
        ))}
      </Tabs>
    </>
  );
};

export default BatchDetail;
